module.exports = __webpack_public_path__ + "c0b08815baf9854eb97c6272ab158017.svg";